import React from 'react';
import { Form, Field } from 'react-final-form';
import firebase from '../common/firebase';
import BaseLayout from '../common/layouts/BaseLayout';
import { Container, FullPreview, FullPreviewBox, Margin } from '../common/base';
import { Textfield, Grid, Col, Button, Alert } from '../common/interfaces';
import HeadShared from '../common/HeadShared';

class PasswordResetRequestForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      sending: false,
      message: null
    };
  }

  onSubmit = data => {
    this.setState({ sending: true });
    firebase
      .auth()
      .sendPasswordResetEmail(data.email)
      .then(() => {
        this.setState({
          message: (
            <Alert
              success
              message="Email sent. Please check your inbox for further instructions."
            />
          )
        });
      })
      .catch(error => {
        this.setState({
          sending: false,
          message: <Alert error message={error.message} />
        });
      });
  };

  render() {
    const { message, sending } = this.state;
    return (
      <BaseLayout headerType="grey">
        <HeadShared title="RupiahToken - Reset Password" desc="Password Reset Request Form" />
        <FullPreview>
          <Container>
            <FullPreviewBox>
              <div>
                <Margin bottom={40}>
                  <h2>Reset Password</h2>
                  <p>Input your resgistered email here</p>
                </Margin>
                {message && <Margin bottom={24}>{message}</Margin>}
                <Grid justify="center" text="left">
                  <Col lg={5} md={8} sm={12}>
                    <Form
                      onSubmit={this.onSubmit}
                      render={({ handleSubmit, pristine, invalid }) => (
                        <form>
                          <Field
                            name="email"
                            render={({ input, meta }) => (
                              <div>
                                {meta.touched && meta.error && <span>{meta.error}</span>}
                                <Textfield
                                  {...input}
                                  label="Email address"
                                  disabled={sending}
                                  type="email"
                                  placeholder="Enter your email address"
                                  required="required"
                                />
                              </div>
                            )}
                          />
                          <Margin top={40}>
                            <Grid justify="center">
                              <Col lg={8} sm={12}>
                                <Button onClick={handleSubmit} size="large" block>
                                  Send reset link
                                </Button>
                              </Col>
                            </Grid>
                          </Margin>
                        </form>
                      )}
                    />
                  </Col>
                </Grid>
              </div>
            </FullPreviewBox>
          </Container>
        </FullPreview>
      </BaseLayout>
    );
  }
}

export default PasswordResetRequestForm;
